import React, { ChangeEvent } from 'react';
import { getFlyingPageFilterText } from '../../redux/selectors/flyingPage';
import { useDispatch, useSelector } from 'react-redux';
import { Input } from 'antd';
const { Search } = Input;
import { setFilterText } from '../../redux/slice/flyingPage/flyingPage';

const FlightFilterTextBox: React.FC = () => {
  const dispatch = useDispatch();
  const filterText = useSelector(getFlyingPageFilterText);

  const search = (event: ChangeEvent<HTMLInputElement>) => {
    event.preventDefault();
    if (filterText !== event.target.value) {
      dispatch(setFilterText(event.target.value));
    }
  };

  return (
    <div className="flight-detail-filter-text-box">
      <Search placeholder="Search for aircraft" value={filterText} allowClear onChange={search} />
    </div>
  );
};

export default FlightFilterTextBox;
